import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Switch from '~/components/ui/atoms/Switch';

export function AsyncSwitch({ checked, onChange, disabled }) {
  const [isActionRunning, setIsActionRunning] = useState(false);

  const handleChange = async (e) => {
    setIsActionRunning(true);
    await onChange(e);
    setIsActionRunning(false);
  };

  return <Switch checked={checked} onChange={handleChange} disabled={disabled || isActionRunning} />;
}

AsyncSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
